module.exports = __webpack_public_path__ + "static/media/night_small.7ef8b90b.jpg";